var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataLoaded)?_c('div',[_vm._m(0),_c('PageBuilder',{attrs:{"cmsBlocks":_vm.home.attributes.cmsBlocks}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"preload"}},[_c('img',{attrs:{"src":require("@/assets/vector_dark.svg"),"rel":"preload"}}),_c('img',{attrs:{"src":require("@/assets/vector_white.svg"),"rel":"preload"}})])
}]

export { render, staticRenderFns }